<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a>Copyright © 2005 by Fay Weldon</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="copyright">First published in Great Britain in 2005 by Fourth Estate, an imprint of <em>HarperCollinsPublishers</em>, London</p>
<p class="copyright"><em>Printed in the United States of America</em></p>
<p class="copyright"><span class="small">FIRST PAPERBACK EDITION</span></p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Weldon, Fay.<br/>   She may not leave / Fay Weldon.<br/>      p. cm.<br/>   eBook ISBN-13: 978-1-5558-4886-6<br/>   1. Au pairs—Fiction. 2. Working mothers—Fiction. 3. Triangles (Interpersonal relations)—Fiction. 4. Child rearing—Fiction. 5. Dependency (Psychology)—Fiction. I. Title.<br/>PR6073.E374S525 2006<br/>813′.54—dc22                                2005057227</p>
<p class="copyright">Grove Press<br/>an imprint of Grove/Atlantic, Inc.<br/>841 Broadway<br/>New York, NY 10003</p>
<p class="copyright">Distributed by Publishers Group West<br/><a class="nounder" href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?a81449b0